export const isNumber = (val: number | string): boolean => {
  return !Number.isNaN(Number(val)) && !Number.isNaN(parseFloat(val?.toString()));
};
